// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_investorSelect__Rf\\+8s {
    border: 0.5px solid #707070;
    padding: 20px 15px 20px;
    cursor: pointer;
    transition: background-color 0.4s;
    min-height: var(--item-min-height);
    max-width: 240px;
    margin: 0;
    background: #fff;
}

.styles_compact__Amjh\\+ h5 {
    margin: auto;
    height: auto;
}

.styles_investorSelect__Rf\\+8s.styles_selected__-ThL- {
    background: var(--primary-color-light);
    border-color: var(--primary-color);
}

.styles_investorSelect__Rf\\+8s:hover {
    color: #fff;
    background: var(--primary-color);
    border-color: var(--primary-color);
}

.styles_investorSelectInput__GEhqs {
    display: none;
}

.styles_investorSelectTitle__5Bcqf {
    height: 40px;
    text-align: center;
    transition: color 0.4s;
}

.styles_investorSelectTitle__5Bcqf:first-letter {
    text-transform: capitalize;
}

.styles_investorSelectInfo__4pvQC {
    font-size: 13px;
    font-weight: 300;
    margin: 0;
    transition: color 0.4s;
    text-align: center;
}

.styles_selectionBox__lJYNJ .styles_investorSelect__Rf\\+8s .styles_investorSelectInfo__4pvQC {
    text-align: center;
}

.styles_investorSelectInfo__4pvQC:first-letter {
    text-transform: uppercase;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    /*.investorSelect {*/
    /*    padding: 8px 8px 8px;*/
    /*}*/

    .styles_investorSelectTitle__5Bcqf {
        height: 20px;
        font-size: 14px;
    }

    .styles_investorSelectInfo__4pvQC {
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectionPopup/SelectionCheckbox/styles.module.css"],"names":[],"mappings":"AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,iCAAiC;IACjC,kCAAkC;IAClC,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,IAAI;;IAEJ;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@value screen-md-max from '../../../breakpoints.css';\n\n.investorSelect {\n    border: 0.5px solid #707070;\n    padding: 20px 15px 20px;\n    cursor: pointer;\n    transition: background-color 0.4s;\n    min-height: var(--item-min-height);\n    max-width: 240px;\n    margin: 0;\n    background: #fff;\n}\n\n.compact h5 {\n    margin: auto;\n    height: auto;\n}\n\n.investorSelect.selected {\n    background: var(--primary-color-light);\n    border-color: var(--primary-color);\n}\n\n.investorSelect:hover {\n    color: #fff;\n    background: var(--primary-color);\n    border-color: var(--primary-color);\n}\n\n.investorSelectInput {\n    display: none;\n}\n\n.investorSelectTitle {\n    height: 40px;\n    text-align: center;\n    transition: color 0.4s;\n}\n\n.investorSelectTitle:first-letter {\n    text-transform: capitalize;\n}\n\n.investorSelectInfo {\n    font-size: 13px;\n    font-weight: 300;\n    margin: 0;\n    transition: color 0.4s;\n    text-align: center;\n}\n\n.selectionBox .investorSelect .investorSelectInfo {\n    text-align: center;\n}\n\n.investorSelectInfo:first-letter {\n    text-transform: uppercase;\n}\n\n@media screen-md-max {\n    /*.investorSelect {*/\n    /*    padding: 8px 8px 8px;*/\n    /*}*/\n\n    .investorSelectTitle {\n        height: 20px;\n        font-size: 14px;\n    }\n\n    .investorSelectInfo {\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"investorSelect": `styles_investorSelect__Rf+8s`,
	"compact": `styles_compact__Amjh+`,
	"selected": `styles_selected__-ThL-`,
	"investorSelectInput": `styles_investorSelectInput__GEhqs`,
	"investorSelectTitle": `styles_investorSelectTitle__5Bcqf`,
	"investorSelectInfo": `styles_investorSelectInfo__4pvQC`,
	"selectionBox": `styles_selectionBox__lJYNJ`
};
export default ___CSS_LOADER_EXPORT___;
